/** Display duration constants for a snackbar (expressed as ms). */
export enum SnackbarDuration {
  Short = 2000,
  Medium = 5000,
  Long = 10000,
}
